import React from "react";
import { IconProps } from "../../utils/global-types/global-types";

const DoNotDisturbIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <g clipPath="url(#clip0_1997_13164)">
        <path
          fill="currentColor"
          d="M16.33 10.59A7.5 7.5 0 0 1 9 16.5 7.496 7.496 0 0 1 1.5 9a7.5 7.5 0 0 1 5.91-7.33.476.476 0 0 1 .486.747 5.48 5.48 0 0 0-1.063 3.25c0 3.03 2.471 5.5 5.5 5.5a5.48 5.48 0 0 0 3.25-1.063c.354-.26.84.056.748.485"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_1997_13164">
          <path fill="#fff" d="M1 1h16v16H1z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default DoNotDisturbIcon;
